export type Venture = {
  name: string;
  description: string;
  href: string;
  displayUrl: string;
  /** Drop a 2x screenshot URL here (16:10, e.g. 2400×1500). */
  screenshot?: string;
};

export const ventures: Venture[] = [
  {
    name: 'Ad ROI Marketing',
    description: 'Websites, marketing and automation for business owners who want results, not headaches.',
    href: 'https://adroimarketing.com',
    displayUrl: 'adroimarketing.com',
    screenshot:
      'https://assets.cdn.filesafe.space/CsfHedhhmiHrpQT8qQjB/media/c1e772d5-fc81-45ad-b79d-d7a50f2ccfef.png',
  },
  {
    name: '1Dash.Pro',
    description:
      'Our all-in-one CRM. Leads, follow-up, calendars and automation in one place. Powered by HighLevel.',
    href: 'https://1dash.pro',
    displayUrl: '1dash.pro',
    screenshot:
      'https://assets.cdn.filesafe.space/CsfHedhhmiHrpQT8qQjB/media/023c89de-026f-4fae-80ac-e3b7bf9272bb.png',
  },
  {
    name: 'Living Websites',
    description:
      "Websites that run themselves. Need a change? Ask for it — by phone, text, email or chat — and it's live in minutes. No web designer needed.",
    href: 'https://adroimarketing.com/#/design/websites',
    displayUrl: 'adroimarketing.com/design/websites',
    screenshot:
      'https://assets.cdn.filesafe.space/CsfHedhhmiHrpQT8qQjB/media/a251a921-1114-46ca-912b-f726e807b1ac.png',
  },
];
